export default function isSaml(identity) {
    try {
        var _a = identity.source, source = _a === void 0 ? "" : _a;
        return source.toLowerCase() === "saml";
    }
    catch (e) {
        return false;
    }
}
